import React, { ReactNode, memo } from "react";
import s from "../ComparisonTable.module.scss";
import cn from "classnames";
import { useHighlightedColumn } from "../ComparisonTable";
import { useHighlighting } from "../hooks/useHighlighting";

type RowProps = {
  feature?: string;
  children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

const Row: React.FC<RowProps> = memo(({ feature, children, ...props }) => {
  const highlightedColumn = useHighlightedColumn();
  const childrenCount = React.Children.count(children);
  const { getColumnProps } = useHighlighting(highlightedColumn, childrenCount);

  const childrenWithHighlight = React.Children.map(children, (child, index) => {
    if (React.isValidElement(child)) {
      const columnProps = getColumnProps(index);

      return React.cloneElement(
        child as React.ReactElement<{
          isHighlighted?: boolean;
          isBeforeHighlighted?: boolean;
          isAfterHighlighted?: boolean;
        }>,
        columnProps
      );
    }
    return child;
  });

  return (
    <div className={cn(s.row)} role="row" {...props}>
      {feature && (
        <div className={cn(s.cell, s.featureCell, s.stickyShadow)} role="cell">
          {feature}
        </div>
      )}
      {childrenWithHighlight}
    </div>
  );
});

Row.displayName = "Row";

export default Row;
